import { CalendarView } from '../../../../components/routes/RoutesCalendar/constants';
import { View } from '../../../../components/scheduling/ViewMenu';
import {
  QueryParamDataType, SchedulingQueryParams, WorkspaceSettingsViews,
} from '../constants';
import dateValidator from './paramValidators/dateValidator';
import viewValidator from './paramValidators/viewValidator';

const SchedulingPageQueryParams = {
  [SchedulingQueryParams.DATE]: {
    required: true,
    customValidator: dateValidator,
    type: QueryParamDataType.DATE,
  },
  [SchedulingQueryParams.VIEW]: {
    required: true,
    customValidator: viewValidator,
    type: QueryParamDataType.CUSTOM,
    acceptedValues: View,
  },
  [SchedulingQueryParams.ROUTE]: {
    required: false,
    type: QueryParamDataType.UUID,
  },
  [SchedulingQueryParams.STOP]: {
    required: false,
    type: QueryParamDataType.UUID,
  },
  [SchedulingQueryParams.ORDER]: {
    required: false,
    type: QueryParamDataType.UUID,
  },
  [SchedulingQueryParams.SETTINGS]: {
    required: false,
    type: QueryParamDataType.CUSTOM,
    acceptedValues: WorkspaceSettingsViews,
  },
  [SchedulingQueryParams.CALENDAR]: {
    required: false,
    type: QueryParamDataType.CUSTOM,
    acceptedValues: CalendarView,
  },
};

export default SchedulingPageQueryParams;
